import { render, staticRenderFns } from "./changeDb.vue?vue&type=template&id=3ac7f6c0&scoped=true"
import script from "./changeDb.vue?vue&type=script&lang=js"
export * from "./changeDb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac7f6c0",
  null
  
)

export default component.exports